import './GanttChartTooltip.css';
export var ganttChartTooltipCSS = '_etlt5g0-2-0-1';